import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=05a856f1&scoped=true&"
import script from "./OpenCard.vue?vue&type=script&lang=js&"
export * from "./OpenCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenCard.vue?vue&type=style&index=0&id=05a856f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a856f1",
  null
  
)

export default component.exports